import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBot = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "url(#gradient)",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-bot-icon lucide-bot",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "gradient",
			x1: 0,
			y1: 0,
			x2: 24,
			y2: 24,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: "0%",
				stopColor: "#C890DE"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: "100%",
				stopColor: "#FD80C1"
			})]
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 4,
			width: .1,
			height: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 4,
			width: 4,
			height: .1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 12,
			x: 4,
			y: 8,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 14,
			width: 2,
			height: .1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 14,
			width: 2,
			height: .1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15,
			y: 13,
			width: .1,
			height: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 13,
			width: .1,
			height: 2
		})
	]
});
export default SvgBot;
